import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Grid from '@material-ui/core/Grid';

import InputControl from '~/components/Input/InputControl';
import MuiInputDate from '~/components/Input/InputDate';

import { editFilter } from '../../../../store/actions';

function InputDate(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    column,
    filter,
    indexGroup,
    indexFilter,
    inputProps,
    ...ownProps
  } = props;

  if (filter.get('operation') === 'between') {
    const [ start = '', end = '' ] = filter.get('value').split('|');

    return (
      <Grid container justify="space-between" spacing={1}>
        <Grid item xs={6}>
          <InputControl
            value={start || end}
            name={'start'}
            inputComponent={MuiInputDate}
            onChange={start => dispatch(editFilter(indexGroup, indexFilter, 'value', `${start}|${end}`))}
            InputProps={{
              type: column.type,
              maxDate: end,
              ...inputProps,
            }}
            {...ownProps}
          />
        </Grid>
        <Grid item xs={6}>
          <InputControl
            value={end || start}
            name={'end'}
            inputComponent={MuiInputDate}
            onChange={end => dispatch(editFilter(indexGroup, indexFilter, 'value', `${start}|${end}`))}
            InputProps={{
              type: column.type,
              minDate: start,
              ...inputProps,
            }}
            {...ownProps}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <InputControl
      value={filter.get('value')}
      name={'value'}
      inputComponent={MuiInputDate}
      onChange={value => dispatch(editFilter(indexGroup, indexFilter, 'value', value))}
      InputProps={{
        placeholder: t('filter-label-value'),
        type: column.type,
        ...inputProps,
      }}
      {...ownProps}
    />
  );
}

export default React.memo(InputDate);
